import { v4 as uuidv4 } from 'uuid';

export default class SessionModel {
    constructor() {
        this._sessionId = null;
    }

    get sessionId() {
        if (this._sessionId === null) {
            this._sessionId = this.generateSessionId();
        }

        return this._sessionId;
    }

    get shortSessionId() {
        return this.sessionId.substring(0, 8);
    }

    generateSessionId() {
        return uuidv4();
    }
}